import { studyExports } from './studyMetadata.js';

// Browser File timestamps are modification times, not filesystem creation times.
export function closestStudy(studies, studyId, pdfModified) {
  const matches = studyExports(studies).filter(
    (study) => String(study.studyId) === String(studyId)
  );
  if (!matches.length) return null;
  const modified = (study) => Number(study.repRevision?.lastModified ?? study.rep?.lastModified);
  if (!Number.isFinite(pdfModified) || matches.some((study) => !Number.isFinite(modified(study))))
    throw new Error(
      `Study ID ${studyId}: file modification time unavailable. Refresh the study folders before retrying.`
    );
  return [...matches].sort(
    (a, b) =>
      Math.abs(modified(a) - pdfModified) - Math.abs(modified(b) - pdfModified) ||
      modified(b) - modified(a) ||
      String(a.id).localeCompare(String(b.id))
  )[0];
}
